export const BLOCKED_PASSWORDS = [
  'password',
  '12345678',
  'qwerty',
  'password123',
  'letmein',
  '123456789',
  '123456',
  'iloveyou',
  'admin',
  'welcome'
];
